import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { O8_CUSTOM_HEADERS } from '@origin8-web/models/core-business';
import { TRACKER_SERVICE, TrackingService } from './tracker.interface';

@Injectable()
export class TrackerInterceptor implements HttpInterceptor {
  private readonly trackerService = inject<TrackingService>(TRACKER_SERVICE);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const requestId = this.trackerService.getRequestId();
    const sessionId = this.trackerService.getSessionId();
    if (req.url === '/assets/config/config.json') {
      return next.handle(req);
    }
    return next.handle(
      req.clone({
        headers: req.headers.set(O8_CUSTOM_HEADERS.TRACE_ID, requestId).set(O8_CUSTOM_HEADERS.SESSION_ID, sessionId),
      }),
    );
  }
}
